export enum GoogleModels {
  //gemma 1
  GEMMA = "gemma", //7b
  GEMMA_2B = "gemma:2b", //2b

  //gemma 2
  GEMMA2_2B = "gemma2:2b", //2b
  GEMMA2 = "gemma2", //9b
  GEMMA2_27B = "gemma2:27b", //27b

  //gemini 1.5
  GEMINI_1_5_FLASH = "gemini-1.5-flash",
  GEMINI_1_5_PRO = "gemini-1.5-pro",
  GEMINI_1_5_FLASH_LITE = "gemini-1.5-flash-lite",

  //gemini 2.0
  GEMINI_2_0_FLASH = "gemini-2.0-flash",
  GEMINI_2_0_FLASH_LITE = "gemini-2.0-flash-lite",

  //gemini 2.5
  GEMINI_2_5_PRO_EXP = "gemini-2.5-pro-exp-03-25",
}

export const GoogleModelsEnabled = [
  GoogleModels.GEMINI_2_0_FLASH,
  GoogleModels.GEMINI_2_0_FLASH_LITE,
  GoogleModels.GEMINI_1_5_FLASH,
  GoogleModels.GEMINI_2_5_PRO_EXP,
]
